import { render, staticRenderFns } from "./BaseDataList.vue?vue&type=template&id=51c8f5e0&scoped=true&"
import script from "./BaseDataList.vue?vue&type=script&lang=js&"
export * from "./BaseDataList.vue?vue&type=script&lang=js&"
import style0 from "./BaseDataList.vue?vue&type=style&index=0&id=51c8f5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8f5e0",
  null
  
)

export default component.exports